<template>
  <main>
    <section
      id="intro"
      class="main-row"
    >
      <b-container>
        <b-row>
          <b-col
            md="7"
            order="2"
            order-md="1"
            class="d-flex flex-column"
          >
            <h1 v-html="$t('meta.title')"></h1>
            <h2 v-html="$t('meta.lead')"></h2>
            <p class="actions d-flex flex-wrap justify-content-center">
              <a
                class="btn btn-lg btn-primary"
                href="https://framapdf.org/signature"
              >
                <div class="d-flex">
                  <i class="fas fa-2x fa-pen pr-3 pt-1"></i>
                  <div class="w-100">
                    <span v-html="$t('intro.actions.pdf.sign.title')"></span>
                    <br />
                    <small
                      v-html="$t('intro.actions.pdf.sign.help')"
                    ></small>
                  </div>
                </div>
              </a>
              <a
                class="btn btn-lg btn-primary"
                href="https://framapdf.org/compress"
              >
                <div class="d-flex">
                  <i class="fas fa-2x fa-down-left-and-up-right-to-center pr-3 pt-1"></i>
                  <div class="w-100">
                    <span v-html="$t('intro.actions.pdf.compress.title')"></span>
                    <br />
                    <small
                      v-html="$t('intro.actions.pdf.compress.help')"
                    ></small>
                  </div>
                </div>
              </a>
              <a
                class="btn btn-lg btn-primary"
                href="https://framapdf.org/organization"
              >
                <div class="d-flex">
                  <i class="fas fa-2x fa-grip pr-3 pt-1"></i>
                  <div class="w-100">
                    <span v-html="$t('intro.actions.pdf.organize.title')"></span>
                    <br />
                    <small
                      v-html="$t('intro.actions.pdf.organize.help')"
                    ></small>
                  </div>
                </div>
              </a>
              <a
                class="btn btn-lg btn-primary"
                href="https://framapdf.org/metadata"
              >
                <div class="d-flex">
                  <i class="fas fa-2x fa-tags pr-3 pt-1"></i>
                  <div class="w-100">
                    <span v-html="$t('intro.actions.pdf.metadata.title')"></span>
                    <br />
                    <small
                      v-html="$t('intro.actions.pdf.metadata.help')"
                    ></small>
                  </div>
                </div>
              </a>
            </p>
            <p>
              <a
                class="btn btn-primary"
                :href="$t('intro.actions.more.url')"
              >
                <i class="fas fa-arrow-up-right-from-square pr-1"></i>
                {{ $t('intro.actions.more.title') }}
              </a>
            </p>
          </b-col>
          <b-col
            md="3"
            lg="4"
            order="1"
            order-md="2"
            class="d-flex justify-content-center align-items-center col-md-5 col-lg-4 order-md-2 order-1"
          >
            <img
              :src="`${$t('baseurl')}img/screens/pdf.png`"
              alt=""
              class="img-fluid shadow-lg"
            />
          </b-col>
        </b-row>
        <b-row
          id="learn-more"
          aria-hidden="true"
          align-h="center"
          class="d-none d-sm-flex"
        >
          <input
            id="btn-learn-more"
            type="checkbox"
            class="sr-only"
            @change="$refs['what']
              .scrollIntoView({ behavior: 'smooth' })"
          />
          <label
            for="btn-learn-more"
            class="btn btn-sm btn-link p-0"
          >
            <span>En savoir plus</span>
            <i class="fas fa-lg fa-chevron-down d-block fc-g8"></i>
          </label>
        </b-row>
      </b-container>
    </section>

    <section
      id="what"
      ref="what"
    >
      <b-container>
        <b-row>
          <b-col>
            <h2 class="sr-only">
              {{ $t('what.title') }}
            </h2>
            <b-tabs
              align="center"
              card
              pills
            >
              <b-tab
                active
                class="p-0"
                :title="$t('what.tab1.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/simplicite.png`" />
                  </b-col>
                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab1.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab2.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                    order-md="2"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/multifonction.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab2.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab3.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/collaboratif.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab3.desc')"
                  />
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <how />

    <why />

    <who />

    <sfs />

    <outro />
  </main>
</template>

<script>
import WebScreen from '../../commons/components/WebScreen.vue';
import How from '../../commons/components/hos/How.vue';
import Why from '../../commons/components/hos/Why.vue';
import Who from '../../commons/components/hos/Who.vue';
import Outro from '../../commons/components/hos/Outro.vue';
import Sfs from '../../commons/components/sfs/Main.vue';

export default {
  components: {
    WebScreen,
    How,
    Why,
    Who,
    Outro,
    Sfs,
  },
};
</script>

<style lang="scss">
#home {
  background: #fff
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="600px" height="600px" viewBox="0 0 100 100"><path d="M5.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 46a2 2 0 10.001-3.999A2 2 0 006 46zM31.5 8a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 10.001-3.999A2 2 0 0028.5 38zm16-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zM40 17.5a1 1 0 100-2 1 1 0 000 2zm-10 31a1 1 0 100-2 1 1 0 000 2zm-12.5-25a1 1 0 100-2 1 1 0 000 2zM77.53 24.742a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-21.5-3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm31.5 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-22.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-25 3.5a2 2 0 100-4 2 2 0 000 4zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM29.5 74a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 70.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM39.5 86a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 97.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 63a2 2 0 10.001-3.999A2 2 0 0020 63zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM77.53 74.242a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-12.5 23.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm14.5-40a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 100-4 2 2 0 000 4zm14.5 11a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm1.5-21a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.5-10.5a1 1 0 100-2 1 1 0 000 2zm-34 15.5a1 1 0 100-2 1 1 0 000 2z" fill="%23e2e8f0" fill-opacity=".3"/></svg>');
  position: relative;
}

#intro {
  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, .2));
  padding: 1rem 0 3rem;
  position: relative;

  &::before, &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before {
    background: var(--f-f7);
    clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);
    // eslint-disable-next-line max-len
    background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xml%3Aspace%3D%22preserve%22%20width%3D%22180%22%20height%3D%22180%22%3E%3Cpath%20d%3D%22M67.716%2064.72a6.531%206.531%200%200%201%206.526-6.525h16.312v13.05a3.26%203.26%200%200%200%203.263%203.262h13.05V89.19H85.661a6.531%206.531%200%200%200-6.526%206.525v14.682h-4.893a6.531%206.531%200%200%201-6.526-6.525zm39.151%206.525h-13.05v-13.05ZM85.661%2094.083h3.262c3.15%200%205.71%202.559%205.71%205.71%200%203.15-2.56%205.709-5.71%205.709h-1.631v3.262c0%20.898-.734%201.632-1.631%201.632a1.636%201.636%200%200%201-1.632-1.632v-13.05c0-.897.734-1.631%201.632-1.631zm3.262%208.156a2.441%202.441%200%200%200%202.447-2.447%202.441%202.441%200%200%200-2.447-2.447h-1.631v4.894zm9.788-8.156h3.262a4.895%204.895%200%200%201%204.894%204.894v6.525a4.895%204.895%200%200%201-4.894%204.894h-3.262a1.636%201.636%200%200%201-1.631-1.632v-13.05c0-.897.734-1.631%201.63-1.631zm3.262%2013.05c.898%200%201.632-.734%201.632-1.631v-6.525c0-.897-.734-1.632-1.632-1.632h-1.63v9.788zm8.157-11.419c0-.897.734-1.631%201.631-1.631h4.894c.897%200%201.631.734%201.631%201.631s-.734%201.631-1.631%201.631h-3.263v3.263h3.263c.897%200%201.631.734%201.631%201.631%200%20.898-.734%201.632-1.631%201.632h-3.263v4.893c0%20.898-.734%201.632-1.63%201.632a1.636%201.636%200%200%201-1.632-1.632v-6.525z%22%20style%3D%22stroke-width%3A.101955%22%2F%3E%3Cpath%20d%3D%22m43.96%2017.984-3.798%203.798%2010.201%2010.201%203.798-3.798a5.02%205.02%200%200%200%200-7.102l-3.092-3.1a5.02%205.02%200%200%200-7.101%200zm-5.572%205.571-18.292%2018.3a6.96%206.96%200%200%200-1.742%202.935l-2.778%209.44a1.884%201.884%200%200%200%202.33%202.346l9.441-2.777a6.96%206.96%200%200%200%202.935-1.743l18.308-18.3Z%22%20style%3D%22stroke-width%3A.0784724%22%2F%3E%3Cpath%20d%3D%22m149.74%2024.624%209.51%209.62a10.114%2010.114%200%200%201%200%2014.227l-8.334%208.43c-.692.7-1.823.708-2.523.016a1.785%201.785%200%200%201-.015-2.523l8.327-8.43a6.544%206.544%200%200%200%200-9.204l-9.502-9.621c-.692-.7-.685-1.83.015-2.523.7-.692%201.83-.684%202.522.015zM124.07%2038.79V27.667c0-1.972%201.6-3.572%203.571-3.572h11.124c1.265%200%202.478.499%203.37%201.392l12.501%2012.5a4.76%204.76%200%200%201%200%206.734l-9.933%209.934a4.76%204.76%200%200%201-6.734%200l-12.5-12.5a4.723%204.723%200%200%201-1.4-3.364zm10.714-6.362a2.381%202.381%200%201%200-4.762%200%202.381%202.381%200%201%200%204.762%200z%22%20style%3D%22stroke-width%3A.0744077%22%2F%3E%3Cpath%20d%3D%22M26.284%20134.076a3.484%203.484%200%200%200-3.486-3.485h-4.182a3.484%203.484%200%200%200-3.485%203.485v4.182a3.484%203.484%200%200%200%203.485%203.486h4.182a3.484%203.484%200%200%200%203.486-3.486zm0%2016.73a3.484%203.484%200%200%200-3.486-3.486h-4.182a3.484%203.484%200%200%200-3.485%203.485v4.183a3.484%203.484%200%200%200%203.485%203.485h4.182a3.484%203.484%200%200%200%203.486-3.485zm2.788-16.73v4.182a3.484%203.484%200%200%200%203.485%203.486h4.183a3.484%203.484%200%200%200%203.485-3.486v-4.182a3.484%203.484%200%200%200-3.485-3.485h-4.183a3.484%203.484%200%200%200-3.485%203.485zm11.153%2016.73a3.484%203.484%200%200%200-3.485-3.486h-4.183a3.484%203.484%200%200%200-3.485%203.485v4.183a3.484%203.484%200%200%200%203.485%203.485h4.183a3.484%203.484%200%200%200%203.485-3.485zm2.788-16.73v4.182a3.484%203.484%200%200%200%203.485%203.486h4.183a3.484%203.484%200%200%200%203.485-3.486v-4.182a3.484%203.484%200%200%200-3.485-3.485h-4.183a3.484%203.484%200%200%200-3.485%203.485zm11.153%2016.73a3.484%203.484%200%200%200-3.485-3.486h-4.183a3.484%203.484%200%200%200-3.485%203.485v4.183a3.484%203.484%200%200%200%203.485%203.485h4.183a3.484%203.484%200%200%200%203.485-3.485z%22%20style%3D%22stroke-width%3A.0871321%22%2F%3E%3Cpath%20d%3D%22M153.61%20119.006a1.903%201.903%200%200%201%202.7%200l2.547%202.548a1.903%201.903%200%200%201%200%202.699l-6.927%206.926%203.105%203.105a1.914%201.914%200%200%201-1.353%203.265h-11.465a1.906%201.906%200%200%201-1.91-1.911v-11.465a1.914%201.914%200%200%201%203.264-1.353l3.105%203.105zm-29.22%2021.098h11.466c1.059%200%201.91.852%201.91%201.911v11.465a1.914%201.914%200%200%201-3.264%201.353l-3.105-3.105-6.926%206.927a1.903%201.903%200%200%201-2.7%200l-2.555-2.548a1.903%201.903%200%200%201%200-2.699l6.927-6.926-3.106-3.113a1.914%201.914%200%200%201%201.354-3.265z%22%20style%3D%22stroke-width%3A.0796169%22%2F%3E%3C%2Fsvg%3E");
    background-color: rgba(0, 0, 0, 0);
    background-size: auto;
    background-size: 300px 300px,400px 400px,600px 600px;
    background-blend-mode: lighten;
    background-color: color-mix(in srgb,var(--f-f7) 97%,transparent);

    @media (max-width: 768px) {
      clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
    }
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1{
    color: var(--f-d1);
    font-size: 5rem;
    font-weight: 300;
    margin: 4rem 0 3rem;

    @media (max-width: 992px) {
      font-size: 4rem;
      margin: 3rem 0 2rem;
    }

    @media (max-width: 768px) {
      font-size: 3rem;
      margin: 2rem 0 1.5rem;
    }
  }

  h2 {
    color: var(--f-d1);
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.25;
    margin: 0;

    @media (max-width: 992px) {
      font-size: 1.75rem;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    color: var(--f-d1);
  }

  .actions, .actions + p {
    margin: 4rem auto 0;
    gap: 0.5rem;

    @media (max-width: 768px) {
      margin: 2rem auto 0.5rem;
      flex-direction: column;
    }

    .btn {
      margin: .25rem .75rem;
      padding: .75rem 1.25rem;
      max-width: 18rem;

      span {
        text-transform: uppercase;
      }

      @media (max-width: 992px) {
        padding: .5rem 1rem;
        max-width: 25rem;
      }

      @media (max-width: 768px) {
        margin: .125rem 0;
      }
    }

    .btn-primary {
      background: var(--f-d1);
      color: var(--f-o7);
      font-weight: 700;
      border: none;
      text-align: start;
      flex: 1;

      &:focus, &:hover {
        background: var(--f-o7);
        color: var(--f-d1);
      }

      i::before {
        color: inherit;
      }
    }
  }

  .actions + p {
    display: flex;
    justify-content: center;
    margin: 1rem auto 3rem;

    @media (max-width: 768px) {
      margin: 0 auto 3rem;
    }
  }

  .btn-outline-light {
    @media (min-width: 768px) {
      border: transparent;
    }
  }

  img {
    max-height: 25vh;
    border-radius: 1.3rem;

    @media (min-width: 992px) {
      max-height: none;
    }
  }

  #learn-more {
    label {
      color: var(--f-d1);
      background: none;
      text-decoration: none;

      i::before {
        color: var(--f-d1);
      }
    }

    span {
      padding: .25rem ;
      font-size: .875rem;
    }

    input:checked ~ label {
      visibility: hidden;
    }
  }
}

#what {
  padding: 4rem 0;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 2rem;

    @media (min-width: 768px) {
      font-size: 3rem;
      line-height: 4rem;
    }
  }

  .card-header {
    border: none;
    background: transparent;
    padding: 0;

    .nav li {
      background: var(--f-g1);
      padding: 0.75rem 1.25rem;
    }
  }

  .card-body .row {
    align-items: center
  }

  h3 {
    font-size: 3rem;
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 1;
    margin: .5rem 0 1rem;

    @media (max-width: 992px) {
      font-size: 2rem;
    }

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  p {
    font-size: 1.35rem;
    font-weight: 200;
    line-height: 1.4;

    @media (max-width: 992px) {
      font-size: 1rem;
    }
  }
}

/* SFS */
#support {
  @media (min-width: 992px) { /* cat is hidden by the form below 992px */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 40px);
  }

  .col-lg-7 .ombre {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  #f-sfs + div { /* #outro parent */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 20px);
  }
}

/* Framanav */
#home #fp-alert {
  background: var(--f-d1);
}

.f-bs4 #f-footer {
  border: none !important;
}
</style>
